import { useEffect, useRef, useState } from 'react';
import ApiDatabase from '../../../../../../server';
import { toPresignedDocs } from '../shared';

/**
 * Signed files of licence entries, current or in history, read once per entry:
 * admin/presignFiles { type: 'licence', licenceId }.
 * @param {object} params
 * @param {string} params.token
 * @param {string} params.userId - user of the temp worker
 * @param {string[]} params.licenceIds
 * @returns {{ docsById: Object<string, Array> }} an id is absent while its files load
 */
const useLicenceDocuments = ({ token, userId, licenceIds }) => {
  const [docsById, setDocsById] = useState({});
  const requestedIds = useRef(new Set());
  const idsKey = licenceIds.join(',');

  useEffect(() => {
    if (!userId) return;
    licenceIds.forEach((licenceId) => {
      if (!licenceId || requestedIds.current.has(licenceId)) return;
      requestedIds.current.add(licenceId);
      const store = (docs) =>
        setDocsById((prev) => ({ ...prev, [licenceId]: docs }));
      ApiDatabase.postPresignFiles(
        { token, idUser: userId, type: 'licence', licenceId },
        (data) => store(toPresignedDocs(data)),
        (err) => {
          if (err?.name === 'CanceledError') {
            requestedIds.current.delete(licenceId);
            return;
          }
          store([]);
        },
        // One request per entry: the default key (the url) would cancel the others.
        { abortKey: `admin/presignFiles/licence/${licenceId}` },
      );
    });
    // idsKey stands for licenceIds, whose array identity changes with every entries update.
  }, [token, userId, idsKey]);

  return { docsById };
};

export default useLicenceDocuments;
